export function classNames(defaultClassName, additionalClassNames) {
    return `${defaultClassName}${additionalClassNames ? " " + additionalClassNames : ""}`;
}